import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/resources/$id/linked-to/")({
  staticData: {
    title: "linkedTo.title",
  },
  beforeLoad: ({ params }) => {
    throw redirect({ to: "/resources/$id/linked-to/fleets", params });
  },
});
